<template>
  <PrivateFileImage
    ref="image"
    :load-access="loadAccess"
    :image-class="imageClass"
    alt="Listing screenshot"
    loading-message="Loading screenshot…"
    error-message="Could not load the screenshot."
    @loaded="$emit('loaded')"
    @error="$emit('error')"
  />
</template>

<script>
import PrivateFileImage from '@/components/common/PrivateFileImage.vue';
import { listingEvidenceAccess } from '@/privateFiles';

export default {
  components: { PrivateFileImage },
  props: {
    cityId: String,
    listingId: String,
    evidence: Object,
    imageClass: String
  },
  emits: ['loaded', 'error'],
  computed: {
    /** Replace the loader when the record or its current screenshot changes. */
    loadAccess() {
      const source = [
        this.cityId,
        this.listingId,
        this.evidence?.status,
        this.evidence?.capturedAt,
        this.evidence?.screenshotGcsPath,
        this.evidence?.screenshotUrl
      ];

      return options => listingEvidenceAccess(source[0], source[1], options);
    }
  },
  methods: {
    /** Keep the existing evidence-printing contract while sharing the image lifecycle. */
    waitUntilReady() {
      return this.$refs.image.waitUntilReady();
    }
  }
};
</script>
